import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { Subject, TimeoutError } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppActivatedRoute, AppRouter, AppTimeoutHandler } from 'src/app/app.module';

@Component({
    template: '',
    standalone: false
})
export abstract class TimeoutableComponent implements OnDestroy, OnInit {

  private destroy$: Subject<void> = new Subject<void>();
  private isActive: boolean;
  public loaded$ = false;
  protected alreadyShowedOfflineOrTimeoutAlert: boolean;
  protected successPageLoad: EventEmitter<boolean> = new EventEmitter<boolean>();
  protected retrySubject = new Subject<void>();

  constructor(
  ) {
    AppRouter.events.pipe(
      takeUntil(this.destroy$),
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((_event) => {
      this.isActive = this.isComponentActive(
        AppRouter.routerState.snapshot.root.pathFromRoot,
        AppActivatedRoute.snapshot.component
      );
    });

    this.retrySubject.subscribe(() => {
      this.alreadyShowedOfflineOrTimeoutAlert = !this.loaded;
    });
  }

  onDestroy() {
    // Cleanup logic
  }

  ngOnDestroy() {
    this.onDestroy();
    this.destroy$?.next();
    this.destroy$?.complete();
    this.isActive = false;
  }

  set loaded(value: boolean) {
    this.loaded$ = value;
    this.successPageLoad.emit(value);
  }

  get loaded(): boolean {
    return this.loaded$;
  }

  // TODO: Add this class to the components that I removed

  ionViewDidEnter?(): any;

  ngOnInit(): any {
    // Default implementation - can be overridden by subclasses
  }

  timeoutHandler(error): Promise<any | undefined> {
    return new Promise<any>((resolve, _reject) => {
      if (this.isActive && !this.loaded && !this.alreadyShowedOfflineOrTimeoutAlert && error instanceof TimeoutError) {

        this.alreadyShowedOfflineOrTimeoutAlert = true;
        AppTimeoutHandler.showTimeoutAlert(this.successPageLoad);
        resolve(null);
      } else {
        resolve(error);
      }
    });
  }

  private isComponentActive(path: ActivatedRouteSnapshot[], component: any): boolean {
    return path.some((ss: ActivatedRouteSnapshot) => ss.component === component || this.isComponentActive(ss.children, component));
  }
}
